export class DocumentLoadAssigEntity {
    id: number;
    userId: number;
    groupId:number;

    constructor (){}
}